import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/advRank',
  title: window.language['flow.advrank'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Flow/AdvRank/index.js